import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/social_links.json";

export const useSocialLinks = () => useSourceFlowCollection(data);

export default useSocialLinks;
